/**
 * PublicOrAppShell — gemeinsame Hülle für die öffentlichen Detailseiten.
 *
 * Extrahiert aus `routes/hotspots.$id.tsx`, `routes/cities.$id.tsx` und
 * `routes/wallets.$id.tsx` (Städteseiten-Relaunch 09.2026): alle drei Routen
 * liegen bewusst AUSSERHALB von `_auth` (Suchmaschinen-Besucher liefen sonst
 * gegen die Login-Wand), zeigen Angemeldeten aber weiterhin die volle
 * AppShell mit Seitenleiste, Anonymen den schlanken PublicPageShell. Die
 * Entscheidung selbst stand identisch in allen drei Dateien.
 */
import type { ReactNode } from 'react'
import { AppShell } from './AppShell'
import { PublicPageShell } from './PublicPageShell'
import { useAuthStore } from '../stores/authStore'

type Props = {
  children: ReactNode
}

export function PublicOrAppShell({ children }: Props) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return isAuthenticated ? <AppShell>{children}</AppShell> : <PublicPageShell>{children}</PublicPageShell>
}
